const isImage = link => link.endsWith('.tif') || link.endsWith('.jpg') || link.endsWith('.jpeg') || link.endsWith('.png');
export default isImage;
